import type { MealSlot } from '@gramas/shared'
import { DisclosureRow, Segmented } from '@gramas/ui'
import { useState } from 'react'
import { SLOT_LABEL, SLOT_ORDER } from '../../db/repo.js'

export interface SlotPickerProps {
  value: MealSlot
  onChange: (slot: MealSlot) => void
}

/**
 * The meal, stated rather than asked.
 *
 * A four-way choice on every single log is a tap spent on a question the clock
 * already answers, and the answer is right nearly every time — a coffee is a
 * snack, food at one o'clock is lunch. So the picker shows what it decided and
 * gets out of the way; touching it opens the four buttons for the times it
 * guessed wrong.
 */
export function SlotPicker({ value, onChange }: SlotPickerProps) {
  const [open, setOpen] = useState(false)

  if (open) {
    return (
      <Segmented
        label="Valgymas"
        value={value}
        onValueChange={(next) => {
          onChange(next as MealSlot)
          setOpen(false)
        }}
        className="w-full"
        options={SLOT_ORDER.map((slot) => ({ value: slot, label: SLOT_LABEL[slot] }))}
      />
    )
  }

  return <DisclosureRow label="Valgymas" value={SLOT_LABEL[value]} onOpen={() => setOpen(true)} />
}
